import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX } from "../Utils";
import { Checkbox, Button, Flex, TextArea } from "@theorgchartdev/storybook";
import { appcstr } from "@coreapp/utils/appcstr";
import { kSageDefaultQuery } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

export const SageSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const { sandbox } = config;

  const updateQuery = value => {
    onChange({ ...config, query: value });
  };

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
    >
      <TextArea
        dataTestId={`${DATA_SOURCES_TEST_PREFIX}-sage-query-textarea`}
        label={appcstr("sfquery")}
        placeholder={appcstr("salesforcecerr5")}
        onChange={e => updateQuery(e.target.value)}
        value={config?.query}
      />
      <Flex direction={"column"} gap={"8px"}>
        <Button
          dataTestId={`${DATA_SOURCES_TEST_PREFIX}-sage-default-query-button`}
          isFullWidth
          modifier={"secondary"}
          onClick={() => updateQuery(kSageDefaultQuery)}
        >
          {`${appstr("Default")} ${appcstr("sfquery")}`}
        </Button>

        <Checkbox
          id={"sandbox-chkbx-sage"}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-sage-sandbox-checkbox`}
          label={appcstr("sfsandbox")}
          size={"medium"}
          checked={sandbox}
          onChange={() => onChange({ ...config, sandbox: !sandbox })}
        />
      </Flex>
    </DataSourceSetupComposite>
  );
};
